import { render, staticRenderFns } from "./DepartmentCreate.vue?vue&type=template&id=51850a48&scoped=true&"
import script from "./DepartmentCreate.vue?vue&type=script&lang=js&"
export * from "./DepartmentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51850a48",
  null
  
)

export default component.exports